import { render } from "./singlecourseV2.vue?vue&type=template&id=69e811fb&scoped=true"
import script from "./singlecourseV2.vue?vue&type=script&lang=js"
export * from "./singlecourseV2.vue?vue&type=script&lang=js"

import "./singlecourseV2.vue?vue&type=style&index=0&id=69e811fb&lang=less&scoped=true"

import exportComponent from "/Users/zhangmohan/work/activitymarketing-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e811fb"]])

export default __exports__